import React from 'react';
import { Link } from 'react-router-dom';
import ReactTimeAgo from 'react-time-ago';
import {
  useGetReportsQuery,
  useGetWorkspacesQuery
} from '../../services/portal';


export default function MyReports({ SearchValue = '', ViewMode = 'tiles' }) {
  const { data: workspaces } = useGetWorkspacesQuery({ forceRefetch: true });
  const { data: reports } = useGetReportsQuery({ forceRefetch: true });
  var workspacePosition = -1;

  if (ViewMode === 'tiles') {
    return (

      <div className="container-fluid mt-3" style={{padding:'0px'}}>
        <div className="row justify-content-start" style={{padding:'0px'}}>

          {reports?.reports
            .filter(
              (r) =>
                r.report_name
                  .toLowerCase()
                  .includes(SearchValue.trim().toLowerCase()) && r.active
            )

            .map((report) => (
              <div key={report.report_id} className="col-md-4 col-sm-5 mb-4" >

                <Link
                  to={`/report/${report.report_type}/${report.workspace.workspace_id}/${report.workspace.workspace_code}/${report.report_id}/${report.report_code}/${report.report_name}`}
                  className="report-tile text-muted"
                  style={{
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: 'transparent',
                    backgroundPosition: 'center',
                    borderRadius: '12px',
                    padding: '20px',
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: '280px',
                    textDecoration: 'none',
                    border: '1px solid rgba(116, 232, 199, 0.3)',
                    boxShadow: '0 0 10px rgba(116, 232, 199, 0.651)',


                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  {/* SVG Gradient Background */}
                  <div className="nucleus_svg-bg" style={{ marginTop: '120px',padding:'30px' }}>
                    <svg viewBox="0 0 400 150" preserveAspectRatio="none">
                      <path
                        className="nucleus_area-fill"
                        d="M 0 85 C 30 65, 50 80, 70 60 S 110 40, 130 55 S 170 35, 190 50 S 230 30, 250 45 S 290 25, 310 35 S 350 20, 370 30 S 400 15, 400 15 L 400 100 L 0 100 Z"
                      />
                      <path
                        className="nucleus_glow"
                        d="M 0 85 C 30 65, 50 80, 70 60 S 110 40, 130 55 S 170 35, 190 50 S 230 30, 250 45 S 290 25, 310 35 S 350 20, 370 30 S 400 15, 400 15"
                      />
                      <path
                        className="nucleus_line"
                        d="M 0 85 C 30 65, 50 80, 70 60 S 110 40, 130 55 S 170 35, 190 50 S 230 30, 250 45 S 290 25, 310 35 S 350 20, 370 30 S 400 15, 400 15"
                      />
                    </svg>
                  </div>


                  <div style={{ position: 'relative', zIndex: 1 }}>
                    <h5 style={{ color: 'white', fontSize: '30px' }}>
                      {report.report_name}
                    </h5>


                  </div>

</Link>

              </div>
            ))}
        </div>
      </div>
    );
  }
  return (
    <div className="card" style={{ backgroundColor: '#0a183a', color: 'white' }}>
      <div className="card-header h5">
        <i className="fas fa-chart-pie text-muted mr-2"></i> My Dashboards
        </div>
      <div className="table-responsive">
        <table className="table">
          <thead></thead>
          <tbody>
            {workspaces?.workspaces
              .filter((workspace) => workspace.active === true)
              .map((item, key) => {
                if (
                  reports?.reports.filter(
                    (report) =>
                      report.workspace.workspace_id === item.workspace_id &&
                      report.active === true &&
                      report.report_name.toLowerCase().includes(SearchValue.trim().toLowerCase())
                  ).length > 0
                ) {
                  return (
                    <React.Fragment key={key}>
                      <tr>
                        <td
                          className="align-middle px-2"
                          style={{ width: '1.5rem' }}>
                          <button
                            type="button"
                            className="btn btn-sm btn-icon custom-hover-focus collased btn2"
                            data-toggle="collapse"
                            data-target={'#details-' + item.workspace_id}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <span className="collapse-indicator">
                              <i className="fa fa-angle-right"></i>
                            </span>
                          </button>
                        </td>
                        <td
                          className="align-middle"
                          style={{ fontSize: '14px', fontWeight: 'bold' }}>
                          {item.workspace_name}
                        </td>
                      </tr>
                      <tr
                        className={`row-details bg-light collapse  ${
                          ++workspacePosition === 0 ? 'show' : ''
                        }`}
                        id={'details-' + item.workspace_id}>
                        <td colSpan="3">
                          <div className="row">
                            <div className="col-md-auto text-center">
                              <div className="tile tile-xl tile-circle bg-primary mb-2">
                                {item.workspace_shortname}
                              </div>
                              <h3 className="card-title mb-4">
                                {item.organization.organization_name}
                              </h3>
                            </div>
                            <div className="col-md-11">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        fontSize: '12px',
                                        width: '60%'
                                      }}>
                                      {' '}
                                      Report{' '}
                                    </th>
                                    {/* <th
                                      style={{
                                        fontSize: '12px',
                                        width: '10%'
                                      }}>
                                      {' '}
                                      Type{' '}
                                    </th>
                                    <th
                                      style={{
                                        fontSize: '12px',
                                        width: '10%'
                                      }}>
                                      {' '}
                                      Created{' '}
                                    </th>
                                    <th style={{ fontSize: '12px' }}>
                                      {' '}
                                      Last Viewed{' '}
                                    </th>*/}
                                   </tr>
                                </thead>
                                <tbody>
                                  {reports?.reports
                                    .filter(
                                      (report) =>
                                        report.workspace.workspace_id ===
                                          item.workspace_id &&
                                        report.active === true &&
                                        report.report_name.toLowerCase().includes(SearchValue.trim().toLowerCase())
                                    )
                                    .map((filteredWorkspace) => (
                                      <tr
                                        key={
                                          'report-' +
                                          filteredWorkspace.report_id
                                        }>
                                         <td className="align-middle">
                                          <Link
                                            // eslint-disable-next-line max-len
                                            to={`/report/${filteredWorkspace.report_type}/${filteredWorkspace.workspace.workspace_id}/${filteredWorkspace.workspace.workspace_code}/${filteredWorkspace.report_id}/${filteredWorkspace.report_code}/${filteredWorkspace.report_name}`}>
                                            {filteredWorkspace.report_name}
                                          </Link>
                                        </td>
                                        {/*<td className="align-middle">
                                          <span className="badge badge-subtle badge-light">
                                            {filteredWorkspace.report_type}
                                          </span>
                                        </td>
                                        <td className="align-middle">
                                          {filteredWorkspace.created_at && (
                                            <ReactTimeAgo
                                              date={Date.parse(
                                                filteredWorkspace.created_at
                                              )}
                                              locale="en-US"
                                            />
                                          )}
                                        </td>
                                        <td className="align-middle">
                                          {filteredWorkspace.viewed_at && (
                                            <ReactTimeAgo
                                              date={Date.parse(
                                                filteredWorkspace.viewed_at
                                              )}
                                              locale="en-US"
                                            />
                                          )}
                                        </td> */}
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                }
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
